package org.ksdfv.thelema.data

/** @author zeganstyl */
enum class DataByteOrder {
    Native,
    LittleEndian,
    BigEndian
}